import React, { useState } from 'react'
import { Button, CollapsibleHeader, FormGrid, FormGroup, Label, Select, Separator, Summary, SummaryItem, SummaryLabel, SummaryValue, Title } from '../../style';
import { ChevronDown, ChevronUp } from 'lucide-react';

const DetailsSection = () => {
  // State to toggle the visibility of the details section
  const [isDetailsOpen, setIsDetailsOpen] = useState(true);
  
  // Mock data for form fields
  const formData = {
    suppliers: [{ name: "Fornecedor LTDA" }], // Supplier data
    sellers: [{ name: "Vendedor S/A" }], // Seller data
    clients: [{ name: "Cliente do Brasil ME" }], // Client data
    orderTypes: [{ name: "Venda" }], // Order type data
    paymentTerms: [{ name: "12x sem juros no boleto" }], // Payment terms
    shippingTypes: [{ name: "Transportes S/A" }], // Shipping type
    trackingCodes: [{ name: "AG987654321BR" }], // Tracking code
    attachments: [{ name: "Pedido_1.docx" }], // Attachments
  };

  // Summary data for order
  const summaryData = {
    quantity: "450",
    taxes: "12,3%",
    total: "R$ 24.456,89",
  }
  
  return(
    <>
      <CollapsibleHeader onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
        <Title>Detalhes do pedido</Title>
        <Button>
          {isDetailsOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </Button>
      </CollapsibleHeader>

      {isDetailsOpen && (
        <>
          <FormGrid style={{ marginTop: '16px' }}>
            <FormGroup>
              <Label>Tipo de pedido</Label>
              <Select>
                <option>{formData.orderTypes[0].name}</option>
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Data do pedido</Label>
              <Select>
                <option>12/12/2025</option>
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Prazo de entrega</Label>
              <Select>
                <option>12/12/2025</option>
              </Select>
            </FormGroup>
          </FormGrid>

          <FormGrid>
            <FormGroup>
              <Label>Condição de pagamento</Label>
              <Select>
                <option>{formData.paymentTerms[0].name}</option>
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Tipo de frete</Label>
              <Select>
                <option>{formData.shippingTypes[0].name}</option>
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Valor do frete</Label>
              <Select>
                <option>R$ 123,45</option>
              </Select>
            </FormGroup>
          </FormGrid>

          <FormGrid>
            <FormGroup>
              <Label>Código de rastreio</Label>
              <Select>
                <option>{formData.trackingCodes[0].name}</option>
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Anexos</Label>
              <Select>
                <option>{formData.attachments[0].name}</option>
              </Select>
            </FormGroup>

            <FormGroup>
              <Label>Informação extra</Label>
              <Select/>
            </FormGroup>
          </FormGrid>
        </>
      )}
      <Separator />
      <Summary>
        <SummaryItem>
          <SummaryLabel>Quantidade de peças:</SummaryLabel>
          <SummaryValue>{summaryData.quantity}</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Tributos:</SummaryLabel>
          <SummaryValue>{summaryData.taxes}</SummaryValue>
        </SummaryItem>
        <SummaryItem>
          <SummaryLabel>Total:</SummaryLabel>
          <SummaryValue>{summaryData.total}</SummaryValue>
        </SummaryItem>
      </Summary>
    </>
  )
}

export default DetailsSection